// External libraries
import styled from '@emotion/styled';
import { css } from '@emotion/core';

// Internal modules
import { BORDER_FOCUSED_COLOR } from '@/styles';

// CSS styles
const customInputContainerStyles = css`
  display: flex;
`;

const inputContainerStyles = css`
  flex-grow: 1;
`;

const inputStyleOverrides = css`
  border-style: none;

  &:focus {
    border-style: none;
    box-shadow: none;
  }
`;

const tooltipStyleOverrides = css`
  margin-top: -1px;
  right: 6px;
  z-index: 11;
`;

// Styled components
const EmailAndTooltipContainer = styled.div`
  position: relative;
`;

const InfoButton = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 50%;
  height: auto;
  margin: 5px 15px 5px 0;
  outline: 0;
  padding: 0;

  &:focus span {
    box-shadow: 0 0 0 3px ${BORDER_FOCUSED_COLOR};
  }
`;

const InfoIconContainer = styled.span`
  align-items: center;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  margin-left: 3px;
  padding: 1px;
`;

export {
  InfoIconContainer,
  customInputContainerStyles,
  EmailAndTooltipContainer,
  InfoButton,
  inputContainerStyles,
  inputStyleOverrides,
  tooltipStyleOverrides,
};
